import { Typography } from "@mui/material"
import { If } from "lib/@components/switch"

export function VersionLockedLabel({ group, isRegimeDraftLocked, regimeDraftVersion }) {
    const { version } = group
    const draftLocked = isRegimeDraftLocked && version == regimeDraftVersion

    return (
        <If truthy={draftLocked}>
            <Typography variant="subtitle1" ml={0.5}>
                - Locked (In Review)
            </Typography>
        </If>
    )
}
